// extracted by mini-css-extract-plugin
export default {"bar":"TopBar-module__bar__oX3hV"};